import { Component, OnInit } from '@angular/core';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { AuthService } from '../service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-internal-login',
  templateUrl: './internal-login.component.html',
  styleUrls: ['./internal-login.component.css']
})
export class InternalLoginComponent implements OnInit {

  token: any;

  constructor(private excursionServiceService:ExcursionServiceService
    ,private auth_service:AuthService
    ,private toastrService: ToastrService
    ,private route: ActivatedRoute) { }
    

  ngOnInit(): void {
    this.route.queryParams.subscribe(params=>{
      console.log(params['Token']);
      this.token = params['Token'];
    });

    const jsonData = { Token: this.token};

    //console.log(this.token);
    this.login_validate(jsonData);
  }

  login_validate(data: {}){
    console.log(data);
    this.excursionServiceService.internal_login_validate(data).subscribe((res: { [x: string]: any; })=>{
      console.log(res);
      if (res['data'][0]['isAuthendicatedLogin']==1){
        this.auth_service.setUser(res['data'][0])
      }
      else {
        this.toastrService.error("Invalid Token");
      }
    });
  }

}